import { isPaletteColor } from '../colorPalette'

/**
 * De kleur per status, zoals de agenda hem als bolletje tekent.
 *
 * Dezelfde weergavelaag als `resolveStatusDisplay` (ADR-032): de statuslijst
 * zelf blijft gedeeld, een organisatie kiest alleen hoe een status eruitziet.
 * De kleur staat naast het eigen woord op `CompagnyMeta.AdressStatusConfig.
 * <sleutel>.Color`, en wordt op dezelfde plek ingesteld.
 *
 * AI-CONTEXT: See docs/decisions.md#adr-032
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 */

/**
 * Standaardkleur per trechterstap van een huishouden. Wat op actie wacht is
 * warm (koraal, amber), wat loopt is turkoois/donker, wat klaar is groen, en
 * wat niet lukt grijs.
 *
 * @type {Record<string, string>}
 */
const ADRESS_STATUS_DEFAULT_COLORS = {
    planning: 'coral',
    awaiting: 'amber',
    planned: 'teal',
    execute: 'dark',
    'follow-up': 'purple',
    completed: 'green',
    unreachable: 'grey',
}

/**
 * @param {Record<string, string>} defaults - Standaardkleur per statussleutel; bepaalt óók welke sleutels er uitkomen
 * @param {Record<string, {Color?: string}>} [config] - `CompagnyMeta.AdressStatusConfig`
 * @returns {Record<string, string>}
 */
const resolveStatusColors = (defaults, config) => {
    // Alles wat geen gewone map is — nog niet geladen, een string, een array —
    // leest als "geen instelling": de standaardkleuren.
    const settings = (config && typeof config === 'object' && !Array.isArray(config))
        ? config
        : {}

    return Object.keys(defaults || {}).reduce((acc, key) => {
        const own = settings[key] && settings[key].Color
        // Een kleur buiten het palet (een oude hexcode, een typefout) heeft
        // geen CSS-klasse en zou een onzichtbaar bolletje geven: dan de standaard.
        acc[key] = isPaletteColor(own) ? own : defaults[key]
        return acc
    }, {})
}

export { ADRESS_STATUS_DEFAULT_COLORS }
export default resolveStatusColors
